import React from 'react';
import { Building2, Factory, Globe2, ShieldCheck } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const menuItems = [
  { name: 'Departments', icon: Building2, path: 'departments' },
  { name: 'Sites', icon: Globe2, path: 'sites' },
  { name: 'Plant Codes', icon: Factory, path: 'plant-codes' },
  { name: 'Plant Requiring Isolations', icon: ShieldCheck, path: 'plant-requiring-isolations' },
];

const MasterSidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="w-64 self-stretch border-r border-gray-200 bg-white">
      <ul className="relative pt-6">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive =
            (location.pathname === '/master' && item.path === 'departments') || location.pathname.includes(`/master/${item.path}`);

          return (
            <li
              key={item.name}
              onClick={() => navigate(`/master/${item.path}`)}
              className={`flex cursor-pointer items-center gap-3 px-6 py-3 transition-colors ${
                isActive ? 'font-medium text-black' : 'text-gray-500 hover:text-black'
              }`}
            >
              <Icon className="h-4 w-4" />
              {item.name}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MasterSidebar;
